import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { TextContentSkeleton } from '../Common/PageSkeleton';
import api from '../../config/api';
import './PolicyPage.css';

const PolicyPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isPrivacy = location.pathname.includes('privacy');
  const isAboutUs = location.pathname.includes('about');
  
  const [policyData, setPolicyData] = useState(null);
  const [loading, setLoading] = useState(true);

  const defaultTitle = isAboutUs ? "About Us" : isPrivacy ? "Privacy Policy" : "Terms & Condition";

  useEffect(() => {
    const fetchPolicy = async () => {
      setLoading(true);
      try {
        let endpoint = '/cms/privacy-policy';
        if (isAboutUs) {
          endpoint = '/cms/about-us';
        } else if (!isPrivacy) {
          endpoint = '/cms/terms-conditions';
        }
        const res = await api.get(endpoint);
        if (res.data) {
          setPolicyData(res.data);
        }
      } catch (err) {
        console.error("Failed to fetch policy data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, [isPrivacy, isAboutUs]);

  return (
    <div className="policy-page-container">
      <header className="policy-header">
        <button onClick={() => navigate(-1)} className="policy-back-btn">
          <ArrowLeft size={24} />
        </button>
        <h1>{policyData?.title || defaultTitle}</h1>
        <div style={{ width: 40 }}></div>
      </header>

      <div className="policy-content">
        {loading ? (
          <TextContentSkeleton />
        ) : policyData?.content ? (

          typeof policyData.content === 'string' && policyData.content.includes('<') ? (
            <div dangerouslySetInnerHTML={{ __html: policyData.content }} />
          ) : (
            <p className="policy-text" style={{ whiteSpace: 'pre-line' }}>{policyData.content}</p>
          )
        ) : (
          <p className="policy-text">No content added yet.</p>
        )}
      </div>
    </div>
  );
};

export default PolicyPage;
